module.exports = __webpack_public_path__ + "static/mainright-8710e98cc59393bb5cac38214cabb95e.jpg";